import React, { FunctionComponent, memo, ReactElement } from 'react';
import clsx from 'clsx';
import modelSelectorItemStyles from './modelSelectorItemStyles';
import { Typography } from '@material-ui/core';
import GenericAccordion from '../../../../../../gqlCommon/components/presentation/genericAccordion/GenericAccordion';

export interface IModelSelectorItemProps {
  expanded: boolean;
  selected: boolean;
  modelName?: string;
  selectVariantTab: (expanded: boolean) => void;
  detailsSlot: ReactElement;
}

const ModelSelectorItem: FunctionComponent<IModelSelectorItemProps> = memo(
  ({ expanded, selectVariantTab, selected, modelName, detailsSlot }) => {
    const styles = modelSelectorItemStyles();

    return (
      <GenericAccordion
        classes={{
          accordionSummary: styles.summary,
          accordionPaper: clsx([styles.root, { [styles.selected]: selected }]),
          accordionSummaryContent: styles.accordionSummaryContent,
          expandIcon: styles.expandIcon,
        }}
        dataTest={`section_${modelName}`}
        summary={
          <Typography variant="subtitle1" className={styles.fullNameText} data-test="title:model">
            {modelName && (
              <>
                <span className={styles.modelNameText} data-test="title:variant">
                  {modelName}
                </span>
              </>
            )}
          </Typography>
        }
        defaultExpanded={false}
        details={detailsSlot}
        expanded={expanded}
        setExpanded={selectVariantTab}
      />
    );
  },
);

export default ModelSelectorItem;
